import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  private websocket: WebSocket | null = null;
  private messageSubject = new Subject<any>();

  connect(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.websocket = new WebSocket(url);

      this.websocket.onopen = () => {
        console.log('WebSocket connection opened');
        resolve();
      };

      this.websocket.onerror = (error) => {
        console.error('WebSocket error:', error);
        reject(error);
      };

      this.websocket.onmessage = (message) => {
        try {
          const data = JSON.stringify(message.data);
          const finalData = JSON.parse(data)
          console.log('data...............', data);
          this.messageSubject.next(finalData);
        } catch (error) {
          console.error('Failed to parse message:', message.data);
          this.messageSubject.next({ error: 'Invalid message format' }); // Handle invalid message
        }
      };

      this.websocket.onclose = () => {
        console.log('WebSocket connection closed');
      };
    });
  }

  sendMessage(data: any): void {
    if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
      this.websocket.send(JSON.stringify(data));
    } else {
      console.error('WebSocket is not open. Unable to send message.');
    }
  }

  getMessages() {
    return this.messageSubject.asObservable();
  }

  close(): void {
    if (this.websocket) {
      this.websocket.close();
    }
  }
}
